import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, Form } from 'react-redux-form'

import { sessionNew } from '../../actions/sessionActions'
import { Button } from '../utils/Button'

const EmailInput = props => (
  <input
    className="text-3xl p-2 border border-gray-300 rounded-md mb-6 block w-full md:w-1/2"
    placeholder="Email Address"
    {...props}
  />
)

const connected = connect(store => {
  return {}
})
export class SessionNewForm extends Component {
  handleSubmit(val) {
    this.props.dispatch(sessionNew(val.forms.email.value))
  }

  render() {
    return (
      <Form model="sessionForm" className="mb-12" onSubmit={val => this.handleSubmit(val)}>
        <Control.text model=".email" component={EmailInput} controlProps={{ placeholder: 'Enter Email Address' }} />
        <Button className="w-full md:w-1/2" color="green">
          Email me a sign in link!
        </Button>
      </Form>
    )
  }
}
export default connected(SessionNewForm)
